/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Better_Studio_Month_JunInputs */

const en_better_studio_month_jun = /** @type {(inputs: Better_Studio_Month_JunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jun`)
};

/**
* | output |
* | --- |
* | "Jun" |
*
* @param {Better_Studio_Month_JunInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const better_studio_month_jun = /** @type {((inputs?: Better_Studio_Month_JunInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Better_Studio_Month_JunInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_better_studio_month_jun(inputs)
});